import { PopoverV2 } from '@kizi/comparator-components';
import { Div, P } from '@kizi/core-components';
import React from 'react';

export const InternetAndChannels = ({
  data,
  productTypes,
  containerStyles = {},
}) => {
  const { downloadSpeedInMb, network, tvChannels, hdChannels } = data;

  return (
    <Div
      css={{
        display: 'flex',
        gap: '24px',
        flexDirection: ['row', 'row', 'column'],
        justifyContent: ['space-between', 'space-between', 'unset'],
        marginTop: ['8px', null, null],
        ...containerStyles,
      }}
    >
      <PopoverV2
        content={
          <P>De maximale downloadsnelheid die haalbaar is met dit pakket.</P>
        }
        placement={'top'}
        trigger="click"
        containerStyles={{ width: '240px' }}
      >
        <Div css={{ cursor: 'pointer' }}>
          <Div
            css={{
              borderBottom: '1px dashed #D9DADE',
              display: 'flex',
              gap: '4px',
              alignItems: 'center',
            }}
          >
            <P variant="bodyImportant" fontSize={['18px', '20px']}>
              {downloadSpeedInMb}
            </P>
            <P variant="footnoteRegular">{' Mbit/s'}</P>
          </Div>

          {network && (
            <P
              mt={'8px'}
              variant="captionRegular"
              color="main.5"
              lineHeight="16px"
              width="max-content"
            >
              {network}
            </P>
          )}
        </Div>
      </PopoverV2>

      {productTypes?.includes('television') && tvChannels && (
        <PopoverV2
          content={
            <P>
              Het aantal tv-zenders en het aantal hd-tv-zenders bij dit product.
            </P>
          }
          placement={'top'}
          trigger="click"
          containerStyles={{
            width: '240px',
          }}
        >
          <Div css={{ cursor: 'pointer' }}>
            <Div
              width="max-content"
              css={{
                borderBottom: '1px dashed #D9DADE',
                display: 'flex',
                gap: '4px',
                alignItems: 'center',
              }}
            >
              <P variant="bodyImportant" fontSize={['18px', '20px']}>
                {tvChannels}
              </P>
              {hdChannels && (
                <P variant="footnoteRegular">{`(${hdChannels} HD)`}</P>
              )}
            </Div>
            <P
              mt={'8px'}
              variant="captionRegular"
              color="main.5"
              lineHeight="16px"
            >
              TV zenders
            </P>
          </Div>
        </PopoverV2>
      )}
    </Div>
  );
};
